<template>
  <div>
    <div class="top-contrainer">
      <div class="layout-header" v-if="version != 'guangdianzhongda' && $route.name === 'caseSearch'">
        <div class="layout-header-system">
          <img
            v-if="projectInfoConfig.fullLogo"
            class="layout-header-system-logo"
            :src="projectInfoConfig.fullLogo"
            @click="goStaticHome"
          />
          <span class="layout-header-system-label">智能类案检索</span>
          <span class="layout-header-system-enterprise" v-if="isEnterprise">企业版</span>
        </div>
        <div class="layout-header-user-info">
          <div class="system-expired-info" v-if="!isEnterprise && !isThird">
            <template v-if="caseInfo">
              <div class="vip-time-info" v-if="caseInfo.dueTime && !caseIsExpired">
                <div class="vip-time-info-content">
                  <img class="vip-time-info-img" src="../../assets/vip@2x.png" alt="" />
                  <span>{{ caseInfo.dueTime | timeFilter }} 到期</span>
                </div>
                <div class="vip-time-info-renew-btn" @click="vipPaneShow = true">续费</div>
              </div>
              <div class="vip-free-surplus" v-else>
                <el-tooltip
                  effect="dark"
                  content="试用次数可用于：普通检索、高级检索、结果中检索、类案明细、类案下载、检索报告生成、检索报告下载"
                  placement="bottom"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <span>免费体验剩余次数：{{ caseFreeSurplus }}次</span>
                <div class="vip-free-surplus-btn" @click="vipPaneShow = true">购买VIP</div>
              </div>
            </template>
          </div>
          <el-dropdown>
            <span class="el-dropdown-link" :style="{ cursor: 'pointer' }">
              <span class="icon-middle" style="width: 30px; margin-right: 10px">
                <img :src="projectInfoConfig.isDefault ? avatarImg1 : avatarImg2" alt="" />
              </span>
              <template v-if="userInfo.tel"
                >{{ userInfo.tel | phoneFilter }}<i class="el-icon-arrow-down el-icon--right"></i
              ></template>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="userInfo.tel">
                <div class="header-portrait">
                  <div class="icon-middle" style="width: 30px; margin-left: -5px; margin-right: 10px">
                    <img :src="projectInfoConfig.isDefault ? avatarImg1 : avatarImg2" alt="" />
                  </div>
                  <div>
                    <p>{{ userInfo.tel | phoneFilter }}</p>
                  </div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="userInfo.tel && !isThird">
                <div class="user-dropdown">
                  <router-link :to="'/case/center'">个人中心</router-link>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="user-dropdown">
                  <router-link :to="'/case/report'">类案检索报告</router-link>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="user-dropdown">
                  <router-link :to="'/case/collect'">类案收藏</router-link>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="!isThird && !projectInfoConfig.hideLogout">
                <div @click="loginOut" class="user-dropdown">
                  <a>退出</a>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="main-header" v-else>
        <div class="left-header" v-if="version != 'guangdianzhongda'">
          <div class="layout-header-system">
            <div class="layout-header-system-back-btn pagejump" v-if="$route.path === '/case/result'" @click="goBack">
              <i class="el-icon-arrow-left"></i>
              <span>返回</span>
            </div>
            <router-link
              to="/case/search"
              v-if="projectInfoConfig.title === '小包公' && $route.path !== '/case/result'"
            >
              <div class="layout-header-system-back-btn">
                <i class="el-icon-arrow-left"></i>
                <span>首页</span>
              </div>
            </router-link>
            <img
              v-if="projectInfoConfig.fullLogo"
              class="layout-header-system-logo"
              :src="projectInfoConfig.fullLogo"
              @click="goStaticHome"
            />
            <span class="layout-header-system-label">智能类案检索</span>
            <span class="layout-header-system-enterprise" v-if="$store.getters.isEnterprise">企业版</span>
          </div>
          <div
            class="search-bar"
            v-if="
              $route.path !== '/case/search' &&
              $route.path !== '/case/report' &&
              $route.path !== '/case/center' &&
              $route.path !== '/case/collect' &&
              !byAiChat
            "
          >
            <div class="search-bar-body" ref="caseInputRef">
              <div class="search-bar-input-content">
                <div class="case-input-item input-val" v-for="(item, index) in key" :key="index">
                  <div v-if="!item.disabled">
                    <el-dropdown placement="bottom-start" trigger="click">
                      <span class="el-dropdown-link" :style="{ whiteSpace: 'nowrap' }">
                        <span class="word-color2">{{ item.type ? item.type.value : '全文' }}</span>
                        <span style="color: #999999"><i class="el-icon-d-caret"></i></span>
                        <span class="word-color1 overflow-ellipsis">{{ item.value }}</span>
                        <span @click.stop="deleteKey(index)" class="search-close-icon" style="color: #222"
                          ><i class="el-icon-close"></i
                        ></span>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(val, i) in paragraphArrGroup" :key="val.key">
                          <div @click="() => (item.type = val)">{{ val.value }}</div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>

                  <div v-else>
                    <span class="el-dropdown-link" :style="{ whiteSpace: 'nowrap' }">
                      <span class="word-color2">{{ item.type }}</span>
                      <span style="color: #999999" v-if="item.disabled">：</span>
                      <span style="color: #999999" v-else><i class="el-icon-d-caret"></i></span>
                      <span class="word-color1 overflow-ellipsis">{{ item.value }}</span>
                      <span @click.stop="deleteKey(index)" class="search-close-icon" style="color: #222"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </div>
                </div>
                <input
                  ref="paraInputRefs"
                  type="text"
                  v-model="searchKey"
                  placeholder="输入关键词或多关键词搜索，中间空格隔开"
                  @focus="showInputTip = true"
                  @blur="searchBarBlurHandle()"
                  @keydown="keySearch($event)"
                  @input="remoteSearch(searchKey)"
                />
              </div>
              <div class="input-tip-panel" :style="{ top: `${caseInputHeight}px` }" v-show="showInputTip">
                <div class="input-tip-panel-title">
                  <span>输入提示</span>
                </div>
                <div class="input-tip-panel-li" :style="{ marginBottom: '5px' }">
                  <span>若要检索多个关键词，中间按空格隔开。</span>
                </div>
                <div class="input-tip-panel-li">
                  <span>1、关键词之间用</span>
                  <el-tooltip effect="dark" content="点击使用" placement="top">
                    <span class="symbol-btn" @click="addSymbolHandle('+')">+</span>
                  </el-tooltip>
                  <span>加号代表“且”的搜索逻辑(如：多次+扒窃)</span>
                </div>
                <div class="input-tip-panel-li">
                  <span>2、关键词之间用</span>
                  <el-tooltip effect="dark" content="点击使用" placement="top">
                    <span class="symbol-btn" @click="addSymbolHandle('|')">|</span>
                  </el-tooltip>
                  <span>竖线的符号表示“或”的搜索逻辑(如：入户盗窃|入室盗窃)</span>
                </div>
                <div class="input-tip-panel-li">
                  <span>3、关键词前面用</span>
                  <el-tooltip effect="dark" content="点击使用" placement="top">
                    <span class="symbol-btn" @click="addSymbolHandle('-')">-</span>
                  </el-tooltip>
                  <span>减号表示“不包含”的搜索逻辑(如：-累犯)</span>
                </div>
                <div
                  class="relate-panel"
                  v-show="
                    searchKey &&
                    (reasons.length > 0 ||
                      labels.length > 0 ||
                      theCourts.length > 0 ||
                      theJudges.length > 0 ||
                      theLawfirms.length > 0 ||
                      theLawers.length > 0 ||
                      theParties.length > 0)
                  "
                  id="popBox"
                >
                  <div class="relate-item-list" v-if="reasons.length > 0">
                    <h5 class="word-normal word-color1">案由</h5>
                    <div
                      class="relate-item"
                      v-for="(item, index) in reasons"
                      :key="index"
                      @click.stop="selectRemote(item, '案由')"
                    >
                      <span class="word-smaller word-color2" v-html="highlight(item.key, searchKey)"></span>
                    </div>
                  </div>
                  <div class="relate-item-list" v-if="labels.length > 0 && false">
                    <h5 class="word-normal word-color1">案情特征</h5>
                    <div
                      class="relate-item"
                      v-for="(item, index) in labels"
                      :key="index"
                      @click.stop="selectRemote(item, '案情特征')"
                    >
                      <span class="word-smaller word-color2" v-html="highlight(item.key, searchKey)"></span>
                    </div>
                  </div>
                  <div class="relate-item-list" v-if="theCourts.length > 0">
                    <h5 class="word-normal word-color1">法院</h5>
                    <div
                      class="relate-item"
                      v-for="(item, index) in theCourts"
                      :key="index"
                      @click.stop="selectRemote(item, '地域及法院')"
                    >
                      <span class="word-smaller word-color2" v-html="highlight(item.key, searchKey)"></span>
                    </div>
                  </div>

                  <div class="relate-item-list" v-if="theJudges.length > 0">
                    <h5 class="word-normal word-color1">法官</h5>
                    <div
                      class="relate-item"
                      v-for="(item, index) in theJudges"
                      :key="index"
                      @click.stop="selectRemote(item, '审判人员')"
                    >
                      <span class="word-smaller word-color2" v-html="highlight(item.key, searchKey)"></span>
                    </div>
                  </div>

                  <div class="relate-item-list" v-if="theLawfirms.length > 0">
                    <h5 class="word-normal word-color1">律所</h5>
                    <div
                      class="relate-item"
                      v-for="(item, index) in theLawfirms"
                      :key="index"
                      @click.stop="selectRemote(item, '律所')"
                    >
                      <span class="word-smaller word-color2" v-html="highlight(item.key, searchKey)"></span>
                    </div>
                  </div>

                  <div class="relate-item-list" v-if="theLawers.length > 0">
                    <h5 class="word-normal word-color1">律师</h5>
                    <div
                      class="relate-item"
                      v-for="(item, index) in theLawers"
                      :key="index"
                      @click.stop="selectRemote(item, '律师')"
                    >
                      <span class="word-smaller word-color2" v-html="highlight(item.key, searchKey)"></span>
                    </div>
                  </div>

                  <div class="relate-item-list" v-if="theParties.length > 0">
                    <h5 class="word-normal word-color1">当事人</h5>
                    <div
                      class="relate-item"
                      v-for="(item, index) in theParties"
                      :key="index"
                      @click.stop="selectRemote(item, '当事人信息')"
                    >
                      <span class="word-smaller word-color2" v-html="highlight(item.key, searchKey)"></span>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="$route.path == '/case/result'">
                <button class="search-button" @click="searchEvent({ inRes: true })">
                  <span>结果中检索</span>
                </button>
                <button class="search-button2" @click="searchEvent({ inRes: false })">
                  <span>新检索</span>
                </button>
                <div class="search-button3" @click="showAccuratePanel = !showAccuratePanel">
                  <img
                    :style="{ position: 'relative', top: '3px', height: '18px' }"
                    src="../../assets/search-select.png"
                  />
                  <span>高级检索</span>
                </div>
              </template>
              <template v-else>
                <button class="search-button" @click="searchEvent({ inRes: false })">
                  <span>检索</span>
                </button>
                <div class="search-button3" @click="showAccuratePanel = !showAccuratePanel">
                  <img
                    :style="{ position: 'relative', top: '3px', height: '18px' }"
                    src="../../assets/search-select.png"
                  />
                  <span>高级检索</span>
                </div>
              </template>
            </div>
          </div>
          <div class="accurate-panel" v-if="showAccuratePanel">
            <advancedSearch v-on:hideAccurate="hideAccurate"></advancedSearch>
          </div>
        </div>
        <div class="left-header" v-else>
          <div class="layout-header-system">
            <div
              class="layout-header-system-back-btn pagejump"
              v-if="$route.path !== '/case/search'"
              @click="goBack"
            >
              <i class="el-icon-arrow-left"></i>
              <span>返回</span>
            </div>
            <img
              v-if="projectInfoConfig.fullLogo"
              class="layout-header-system-logo"
              :src="projectInfoConfig.fullLogo"
              @click="goStaticHome"
            />
            <span class="layout-header-system-label">智能类案检索</span>
          </div>
        </div>
        <div class="right-header" v-if="version != 'guangdianzhongda' && !isThird">
          <el-dropdown trigger="click" v-if="isThird || userInfo.tel">
            <span class="el-dropdown-link" :style="{ whiteSpace: 'nowrap' }">
              <span class="icon-middle" style="width: 30px; margin-right: 10px">
                <img :src="projectInfoConfig.isDefault ? avatarImg1 : avatarImg2" alt="" />
              </span>
              <template v-if="userInfo.tel"
                >{{ userInfo.tel | phoneFilter }}<i class="el-icon-arrow-down el-icon--right"></i
              ></template>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="userInfo.tel">
                <div class="header-portrait">
                  <div class="icon-middle" style="width: 30px; margin-left: -5px; margin-right: 10px">
                    <img :src="projectInfoConfig.isDefault ? avatarImg1 : avatarImg2" alt="" />
                  </div>
                  <div>
                    <p>{{ userInfo.tel | phoneFilter }}</p>
                  </div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="userInfo.tel && !isThird">
                <div class="user-dropdown">
                  <router-link :to="'/case/center'">个人中心</router-link>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="user-dropdown">
                  <router-link :to="'/case/report'">类案检索报告</router-link>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="user-dropdown">
                  <router-link :to="'/case/collect'">类案收藏</router-link>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="!isThird && !projectInfoConfig.hideLogout">
                <div @click="loginOutHome" class="user-dropdown">
                  <a>退出</a>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-else>
            <a @click="showLogin = true">登录</a>
            <el-button @click="showRegister = true" type="primary">注册</el-button>
          </div>
        </div>
        <div class="right-header" v-else>
          <span class="el-dropdown-link" v-if="userInfo.id"> </span>
          <div v-else>
            <a @click="loginGdStatus = true" type="primary">登录</a>
          </div>
        </div>
      </div>
    </div>
    <router-view ref="home" v-on:hideSearch="hideSearch" v-on:clearSearchKey="clearSearchKey"></router-view>

    <!-- 广电仲达登录 -->
    <el-dialog
      width="360px"
      custom-class="memberDialog local-login"
      :show-close="loginGdClose"
      :visible.sync="loginGdStatus"
      title="手机号免密登录"
      @close="closeLocalLogin"
      :close-on-click-modal="false"
    >
      <div>
        <div class="form">
          <el-input v-model="model.tel" type="text" placeholder="手机号"></el-input>
        </div>
        <div class="form">
          <el-input v-model="model.verificode" type="text" placeholder="验证码"></el-input>
          <a class="send-number" @click="sendCode" :disabled="disabled">{{ sendWord }}</a>
        </div>

        <div style="margin: 40px 0 80px">
          <div>
            <el-button style="width: 100%; background: @mainColor" @click="verifiEvent" type="primary"
              >立即登录</el-button
            >
          </div>
        </div>
        <div class="form">
          <span
            >登录即代表同意<span style="color: #4a90e2; cursor: pointer" @click="agreement = true"
              >《用户注册协议》</span
            >和<span style="color: #4a90e2; cursor: pointer" @click="privacy = true">《隐私政策》</span></span
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="360px"
      custom-class="memberDialog"
      :visible.sync="perssion"
      title="登录"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <div style="margin-top: 30px">
        <div class="form">
          <p class="form-label">用户名</p>
          <el-input v-model="model.name" type="text" placeholder="请输入用户名"></el-input>
        </div>
        <div class="form">
          <p class="form-label">密码</p>
          <el-input v-model="model.password" type="password" placeholder="请输入密码"></el-input>
        </div>
        <div class="form">
          <el-checkbox v-model="remember">记住密码</el-checkbox>
        </div>
        <div style="margin-top: 22px">
          <el-button style="width: 100%; background: @mainColor" @click="loginEvent" type="primary">登录</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="500px" custom-class="freeDialog" :visible.sync="freeTime" :close-on-click-modal="false">
      <div class="code-panel">
        <h4>免费试用已结束</h4>
        <p class="if word-middle">如需继续使用系统，请购买许可证密钥。</p>
        <div class="code-bar">
          <p>如果你已经购买了许可证密钥，请输入 License Key</p>
          <el-input v-model="secretKey" type="text" placeholder="xxxx-xxxx-xxxx-xxxx"></el-input>
          <div style="text-align: right; margin-top: 10px">
            <el-button style="width: 120px" type="primary" @click="activationEvent">激活</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="700px"
      custom-class="buyVipDialog"
      :visible.sync="buyVip && productList.length > 0"
      :show-close="true"
      :close-on-click-modal="true"
      @close="closeDialog"
    >
      <div class="buy-panel">
        <div class="buy-panel-top">
          <div class="header-portrait">
            <div style="margin: 0 10px 10px 10px">
              <span style="width: 32px" class="icon-big"><img src="../../assets/default-icon-64.png" alt="" /></span>
            </div>
            <div class="tel">
              <p>{{ userInfo.tel }}</p>
            </div>
          </div>
        </div>
        <div class="buy-panel-body">
          <div class="buy-panel-left">
            <ul>
              <li
                @click="choicePro(item)"
                :class="activeBuy == item.name ? 'cur' : ''"
                v-for="(item, index) in productList"
                :key="index"
              >
                <span class="vip-list-icon">
                  <img src="../../assets/vip-list.png" alt="" />
                  <img src="../../assets/vip-list-gray.png" alt="" />
                </span>
                <a>{{ item.name }}</a>
              </li>
            </ul>
          </div>
          <div class="buy-panel-right">
            <h4>{{ productModel.name }}VIP套餐</h4>
            <div style="display: flex">
              <div
                v-for="(col, idx) in productModel.subItem"
                :key="idx"
                class="sub-pro"
                @click="choiceWay(col, idx)"
                :class="activeWay == idx ? 'cur' : ''"
              >
                <p v-if="col.productList[0].chargeType == 'month'">{{ col.productList[0].chargeCycle }}个月</p>
                <p v-else>{{ col.productList[0].chargeCycle }}次</p>
                <span>¥{{ col.discountPrince }}</span>
                <s>原价{{ col.firstPrince }}</s>
              </div>
            </div>

            <div class="vip-tip">
              <div v-if="productModel.descHtml" v-html="productModel.descHtml"></div>
              <template v-else>
                <p>VIP特权</p>
                <span class="word-normal">{{ productModel.desc }}</span>
              </template>
            </div>

            <div class="pay-panel">
              <div id="qrcode" ref="qrcode"></div>
              <div style="margin-left: 20px">
                <div style="color: #222; font-size: 16px; margin-bottom: 10px">应付金额</div>
                <div>
                  <span style="color: #e42626; font-size: 28px; font-weight: bold"> ¥{{ way.discountPrince }} </span>
                  <s style="color: #999" class="word-normal" v-if="way.firstPrince"> 原价{{ way.firstPrince }}元 </s>
                </div>
                <div style="margin-top: 27px">
                  <span class="wechat-pay"><img src="../../assets/wechat-pay.png" alt="" /></span>
                  <span>使用微信扫码支付</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <div
      class="right-tools"
      v-if="$route.path !== '/case/search' && $route.path !== '/case/report' && $route.path !== '/case/collect'"
    >
      <div class="tool-btn red-btn" @click="reportModalShow = true" v-if="!byAiChat">
        <div class="collect-content">
          <el-badge
            type="primary"
            :value="$store.getters.reportCases.length"
            :hidden="!$store.getters.reportCases.length"
          >
            <img :style="{ width: '14px', marginBottom: '2px' }" :src="reportImg" />
          </el-badge>
          <span>生成检索报告</span>
        </div>
      </div>
      <div class="tool-btn" @click="openCollectPane" v-if="!byAiChat">
        <div class="collect-content">
          <img :style="{ width: '14px', marginBottom: '2px' }" :src="collectImg" />
          <span>收藏夹</span>
        </div>
      </div>
      <div class="tool-btn" @click="backTop">
        <i class="el-icon-top"></i>
      </div>
    </div>

    <el-dialog
      title="收藏夹"
      :visible.sync="collectPaneShow"
      width="700px"
      custom-class="dialog-hide-header-content"
      :before-close="() => (collectPaneShow = false)"
    >
      <caseCollectPane
        @refresList="$refs.home.refreshHandle()"
        v-if="collectPaneShow"
        @routeCase="() => (collectPaneShow = false)"
      >
        <div class="close-btn word-middle word-color2" slot="header-close-btn" @click="collectPaneShow = false">
          <i class="el-icon-close"></i>
        </div>
      </caseCollectPane>
      <span slot="footer" class="dialog-footer">
        <el-button @click="collectPaneShow = false">关 闭</el-button>
      </span>
    </el-dialog>

    <vipPane v-if="vipPaneShow" :show.sync="vipPaneShow" vipType="case" />
    <caseReportCreator v-if="reportModalShow" :show.sync="reportModalShow" />
  </div>
</template>

<script>
import { uniqueId } from 'lodash';
import QRCode from 'qrcodejs2';
import $ from 'jquery';
import { highlight } from '../../filter';
import advancedSearch from './advancedSearch.vue';
import Home from '@/views/forecast/home';
import vipPane from '@/components/vipPane';
import { mapGetters } from 'vuex';
import { defaultFilterList, optionFilterList, otherFilterList, projectInfoConfig } from '@/constant';
import elementResizeDetectorMaker from 'element-resize-detector';
import { services } from '@/service';
import collectImg from '@/assets/收藏-右侧.png';
import caseCollectPane from '@/views/cases/components/caseCollectPane';
import publicUtilFunc from '../../../src/common/js/publicUtil';
import reportImg from '@/assets/报告@2x.png';
import caseReportCreator from './components/caseReportCreator';
import avatarImg1 from '@/assets/default-icon.png';
import avatarImg2 from '@/assets/default-avatar.png';

const publicUtil = publicUtilFunc();

export default {
  data() {
    return {
      projectInfoConfig,
      avatarImg1,
      avatarImg2,
      reportModalShow: false,
      version: window.version,
      model: {
        tel: '',
        password: '',
        name: '',
        verificode: ''
      },
      disabled: false,
      sendWord: '发送验证码',
      userInfo: {},
      searchKey: '',
      selectType: '全文检索',
      secretKey: '',
      typeData: [
        {
          name: '全文检索',
          value: '全文检索'
        },
        {
          name: '标题',
          value: '标题'
        },
        {
          name: '本院认为',
          value: '本院认为'
        },
        {
          name: '判决结果',
          value: '裁判结果'
        },
        {
          name: '本院查明',
          value: '本院查明'
        },
        {
          name: '当事人信息',
          value: '当事人信息'
        }
      ],
      showBack: false,
      remember: true,
      productList: [],
      activeBuy: '',
      productModel: {},
      activeWay: '',
      way: {},
      orderId: '',
      payTimeOut: '',
      reasons: [],
      labels: [],
      titles: [],
      theCourts: [],
      theLaws: [],
      theJudges: [],
      theLawfirms: [],
      theLawers: [],
      theParties: [],
      showAccuratePanel: false,
      caseInputHeight: 34,
      showInputTip: false,
      key: [],
      paragraphArr: [],
      reportImg,
      collectImg,
      collectPaneShow: false,
      loginGdStatus: false,
      loginGdClose: true,
      vipPaneShow: false
    };
  },

  components: { Home, advancedSearch, caseCollectPane, vipPane, caseReportCreator },
  computed: {
    ...mapGetters([
      'perssion',
      'freeTime',
      'buyVip',
      'isEnterprise',
      'caseIsExpired',
      'caseFreeSurplus',
      'caseInfo',
      'isThird'
    ]),
    paragraphArrGroup() {
      const groupObj = _.groupBy(this.paragraphArr, 'groups');
      return groupObj['裁判文书'] || [];
    },
    byAiChat() {
      return this.$route.path === '/case/result/detail' && !!this.$route.query.chatId;
    }
  },
  watch: {
    buyVip: function (val) {
      if (!val && this.payTimeOut) {
        clearInterval(this.payTimeOut);
      }
      if (val) {
        this.choiceWay(this.productModel.subItem[0], 0);
      }
    },
    '$route.query': function (val) {
      this.showAccuratePanel = false;
    },
    $route() {
      this.searchKey = '';
    }
  },
  beforeDestroy() {
    if (this.erdRemoveFn) {
      this.erdRemoveFn();
    }
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.caseInputRef) {
        const erd = elementResizeDetectorMaker();
        const listenFn = (element) => {
          this.caseInputHeight = element.offsetHeight + 5;
          console.log(this.caseInputHeight);
        };
        erd.listenTo(this.$refs.caseInputRef, listenFn);
        this.erdRemoveFn = () => {
          erd.removeListener(this.$refs.caseInputRef, listenFn);
        };
      }
    });
    this.initParagraphHandle();

    this.$store.state.loading = false;
    if (localStorage.getItem('token')) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    } else {
      localStorage.removeItem('userInfo');
    }
    if (this.$route.query.fullText) {
      this.searchKey = this.$route.query.fullText;
      this.searchEvent({ inRes: this.$route.path == '/case/result' });
    }
    let infoStr = window.localStorage.getItem('loginInfo');
    if (infoStr) {
      this.model.name = decodeURIComponent(JSON.parse(infoStr).name);
      this.model.password = decodeURIComponent(JSON.parse(infoStr).password);
    }
    var that = this;
    document.onkeydown = function (e) {
      e = window.event || e;
      if (that.perssion && (e.code == 'Enter' || e.code == 'enter')) {
        //验证在登录界面和按得键是回车键enter
        that.loginEvent(); //登录函数
      }
    };
    if (this.userInfo.tel) {
      this.httpGet('user/products?purpose=PC').then((data) => {
        if (data && data.statusCode == 1) {
          // this.productList = data.data;
          data.data.forEach((v) => {
            var find = _.find(this.productList, { name: v.name });
            if (!find) {
              v.subItem = [];
              v.subItem.push({
                id: v.id,
                name: v.name,
                desc: v.desc,
                descHtml: v.descHtml,
                chargeCycle: v.chargeCycle,
                chargeType: v.chargeType,
                payPrince: v.payPrince,
                discountPrince: v.discountPrince,
                productList: v.productList,
                firstPrince: v.firstPrince,
                userType: v.userType
              });
              this.productList.push(v);
            } else {
              find.subItem.push({
                id: v.id,
                name: v.name,
                desc: v.desc,
                descHtml: v.descHtml,
                chargeCycle: v.chargeCycle,
                chargeType: v.chargeType,
                payPrince: v.payPrince,
                discountPrince: v.discountPrince,
                productList: v.productList,
                firstPrince: v.firstPrince,
                userType: v.userType
              });
            }
          });
          if (data.data.length > 0) {
            this.activeBuy = data.data[0].name;
            this.productModel = data.data[0];
          }
        }
      });
    }
    if (this.$route.path != '/case/search' && !this.userInfo.tel && window.version == 'guangdianzhongda') {
      this.loginGdStatus = true;
      this.loginGdClose = false;
    }
  },

  methods: {
    getUserInfo() {
      this.httpGet(`admin/user`).then((res) => {
        if (res && res.statusCode == 1) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          sessionStorage.setItem('_USER_INFO_', JSON.stringify(res.data));
          this.userInfo = res.data;
          // this.$message({
          //   message: "登录成功",
          //   type: "success",
          // });

          console.log(this.loginGdStatus, this.userInfo.tel, window.version);
          if (this.loginGdStatus && this.userInfo.tel && window.version == 'guangdianzhongda') {
            window.location.reload();
          }
        } else {
          this.$message({
            message: res.message,
            type: 'warning'
          });
        }
      });
    },
    verifiEvent() {
      if (!this.model.tel) {
        this.$message({
          message: '请输入手机号',
          type: 'warning'
        });
        return;
      }
      if (!this.model.verificode) {
        this.$message({
          message: '请输入验证码',
          type: 'warning'
        });
        return;
      }
      if (this.model.verificode.length > 6) {
        this.$message({
          message: '请输入正确的验证码',
          type: 'warning'
        });
        return;
      }
      this.httpPost('user/valid', {
        tel: this.model.tel,
        code: this.model.verificode
      }).then((data) => {
        if (data && data.statusCode == 1) {
          if (data.data.token) {
            window.localStorage.setItem('token', data.data.token);
            sessionStorage.setItem('_TOKEN_', data.data.token);

            this.getUserInfo();
          } else {
            this.$message({
              message: data.data.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: data.message,
            type: 'warning'
          });
        }
      });
    },
    sendCode() {
      if (!this.model.tel) {
        this.$message({
          message: '请输入手机号',
          type: 'warning'
        });
        return;
      }
      if (this.sendWord !== '重新发送' && this.sendWord !== '发送验证码') {
        return;
      }

      var time = 60;
      var timer = setInterval(() => {
        time--;
        this.sendWord = `${time}s`;
        if (time == 0) {
          clearInterval(timer);
          this.sendWord = '重新发送';
          this.disabled = false;
        }
      }, 1000);

      this.disabled = true;

      this.httpPost('user/sms/send', { tel: this.model.tel }).then((data) => {
        if (data && data.statusCode == 1) {
          this.$message({
            message: '发送成功',
            type: 'success'
          });
        } else {
          this.$message({
            message: data.message,
            type: 'warning'
          });
        }
      });
    },
    closeLocalLogin() {
      this.$store.commit('setLocalLogin', false);
    },
    addSymbolHandle(symbol) {
      const refItem = this.$refs.paraInputRefs;
      const start = refItem.selectionStart;
      const keyWord = this.searchKey;
      this.searchKey = `${keyWord.slice(0, start)}${symbol}${keyWord.slice(start)}`;
      this.$nextTick(() => {
        refItem.focus();
        refItem.selectionStart = start + 1;
        refItem.selectionEnd = start + 1;
      });
    },
    openCollectPane() {
      this.collectPaneShow = true;
      services.logger.handleLog({ operateName: '类案点击右侧收藏夹' });
    },
    async initParagraphHandle() {
      this.paragraphArr = await services.labelRelation.getParagraph();
    },
    deleteKey(index) {
      this.key.splice(index, 1);
    },
    goDashboard() {
      this.$router.push({
        path: '/forecast/dashboard'
      });
    },
    closeDialog() {
      this.$store.commit('setBuyVip', false);
    },
    loginOutHome() {
      this.httpGet('admin/logout').then((data) => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('_TOKEN_');
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        sessionStorage.removeItem('userInfo');
        this.userInfo = {};
        if (this.version == 'guangdianzhongda') {
          location.href = window.location.origin + '/home.html#/case/search';
        } else {
          this.goStaticHome();
        }
      });
    },
    highlight: highlight,
    hideAccurate(isRoute) {
      this.showAccuratePanel = false;
      if (isRoute) {
        if (this.$route.path === '/case/result') {
          this.$refs.home.refreshHandle();
        } else {
          this.$router.push('/case/result');
        }
      }
    },
    goStaticHome() {
      if (this.isThird) {
        return;
      }
      var locationHref = window.location.href;
      location.href = locationHref.slice(0, locationHref.indexOf('/home.html')) + '/index.html';
    },
    qrcode(name, id, discountPrince) {
      this.httpPost('wechat/order', { productId: id, price: discountPrince, body: '小包公-' + name }).then((data) => {
        if (data && data.statusCode == 1) {
          let qrcode = new QRCode('qrcode', {
            width: 130, // 二维码宽度，单位像素
            height: 130, // 二维码高度，单位像素
            text: data.data.codeUrl // 生成二维码的链接
          });
          this.orderId = data.data.orderId;
          clearInterval(this.payTimeOut);
          this.payTimeOut = setInterval(() => {
            this.getOrderStatus();
          }, 2000);
        } else {
          this.$message({
            message: data.message,
            type: 'warning'
          });
        }
      });
    },
    openBuyVip() {
      if (this.productModel.subItem && this.productModel.subItem.length > 0) {
        //  this.choiceWay(this.productModel.subItem[0],0);
        this.$store.commit('setBuyVip', true);
      } else {
        this.$message({
          message: '获取产品失败，请稍后再试',
          type: 'warning'
        });
      }
    },
    selectRemote(item, type) {
      console.log(item);
      console.log(type);
      var model = {
        type: type,
        value: item.key,
        id: item.id,
        disabled: true
      };
      if (type === '案由') {
        model.isCrime = true;
        model.crimeId = item.id;
      }
      this.key.push(model);
      this.searchKey = '';
    },
    searchBarBlurHandle() {
      const inputItem = this.$refs.paraInputRefs;
      setTimeout(() => {
        if (inputItem !== document.activeElement) {
          this.showInputTip = false;
        }
      }, 150);
    },
    async remoteSearch(keyword = '') {
      if (this.searchKey) {
        this.reasons = [];
        this.labels = [];
        this.titles = [];
        this.theCourts = [];
        this.theJudges = [];
        this.theLawfirms = [];
        this.theLawers = [];
        this.theParties = [];
        if (this.searchKey !== keyword && keyword === '') {
          this.searchKey = '';
        }
        var dataMap = [
          'reasons',
          'labels',
          'titles',
          'theCourts',
          'theJudges',
          'theLawfirms',
          'theLawers',
          'theParties'
        ];
        const data = await this.httpPost(`nlp/case/reminder`, { text: this.searchKey });
        if (data) {
          data.data.forEach((v, i) => {
            this[dataMap[i]] = v;
          });
        } else {
          this.$message({
            type: 'warning',
            message: data.message
          });
        }
      }
    },
    qrcode(name, id, discountPrince) {
      this.httpPost('wechat/order', { productId: id, price: discountPrince, body: '小包公-' + name }).then((data) => {
        if (data && data.statusCode == 1) {
          let qrcode = new QRCode('qrcode', {
            width: 130, // 二维码宽度，单位像素
            height: 130, // 二维码高度，单位像素
            text: data.data.codeUrl // 生成二维码的链接
          });
          this.orderId = data.data.orderId;
          clearInterval(this.payTimeOut);
          this.payTimeOut = setInterval(() => {
            this.getOrderStatus();
          }, 2000);
        } else {
          this.$message({
            message: data.message,
            type: 'warning'
          });
        }
      });
    },
    getOrderStatus() {
      this.httpGet(`wechat/order/${this.orderId}`).then((data) => {
        if (data && data.statusCode == 1) {
          if (data.data.status == 'SUCCESS') {
            clearInterval(this.payTimeOut);
            this.$message({
              message: '支付成功',
              type: 'success'
            });
            this.$store.commit('setBuyVip', false);
          }
        }
      });
    },
    choicePro(item) {
      this.productModel = item;
      this.activeBuy = item.name;
      this.choiceWay(this.productModel.subItem[0], 0);
    },
    choiceWay(col, index) {
      this.activeWay = index;
      this.way = col;
      this.$nextTick(() => {
        document.getElementById('qrcode').innerHTML = '';
        this.qrcode(col.name, col.id, col.discountPrince);
      });
    },
    keySearch(e) {
      if (e.keyCode == 32) {
        if (this.searchKey) {
          services.logger.handleLog({ operateName: '搜索框空格添加段落筛选' });
          this.key.push({
            type: '',
            value: this.searchKey,
            isKeyword: true
          });
          setTimeout(() => {
            this.searchKey = '';
          }, 100);
        }
      }
      if (e.keyCode == 13) {
        if (this.key.length > 0 || this.searchKey) {
          this.searchEvent({ inRes: this.$route.path == '/case/result' });
        }
      }
    },
    activationEvent() {
      let param = {
        secretKey: this.secretKey
      };
      this.httpPost('admin/period', param).then((data) => {
        if (data && data.statusCode == 1) {
          this.$store.commit('setFreeTime', false);
          this.$message({
            message: '激活成功',
            type: 'success'
          });
          var that = this;
          setTimeout(() => {
            that.$router.go(0);
          }, 1000);
        } else {
          this.$message({
            message: data.message,
            type: 'warning'
          });
        }
      });
    },
    searchEvent({ inRes = true }) {
      if (this.searchKey) {
        this.key.push({
          type: '',
          value: this.searchKey,
          isKeyword: true
        });
        this.searchKey = '';
      }
      if (this.key.length < 1) {
        return;
      }

      const caseFilterList = inRes ? JSON.parse(sessionStorage.getItem('caseFilterList') || '[]') : [];
      const searchTextList = [];

      this.key.forEach((item) => {
        let defaultFilterInfo = [...defaultFilterList, ...optionFilterList, ...otherFilterList].find((subItem) => {
          const name = item.isKeyword ? '全文检索' : item.type;
          return subItem.name === name || (subItem.subName || []).includes(name);
        });
        defaultFilterInfo = _.cloneDeep(defaultFilterInfo);
        defaultFilterInfo.bySearchInput = true;
        let val = item.value;
        if (item.isKeyword) {
          searchTextList.push(item.value);
          val = {
            id: `${Date.now()}_${uniqueId()}`,
            keyword: item.type ? item.type.key : '',
            value: item.value,
            word: item.value
          };
          defaultFilterInfo.result = [];
        }

        if (item.isCrime) {
          defaultFilterInfo.formatter([{ id: item.crimeId, name: val }]);
        } else if (item.id) {
          defaultFilterInfo.formatter([{ id: item.id, name: val }]);
        } else {
          defaultFilterInfo.formatter(val);
        }
        caseFilterList.push(defaultFilterInfo);
      });
      sessionStorage.setItem('caseFilterList', JSON.stringify(caseFilterList));
      services.logger.handleLog({ operateName: inRes ? '在结果中检索' : '新检索' });
      services.logger.handleLog({ operateName: '类案普通检索', otherParams: { info: searchTextList } });
      this.searchKey = '';
      this.key = [];
      if (this.$route.path === '/case/result') {
        this.$refs.home.refreshHandle();
      } else {
        this.$router.push('/case/result');
      }
    },
    backTop() {
      $('html').animate(
        {
          scrollTop: 0
        },
        300
      );
    },
    hideSearch(val) {
      this.showBack = val;
    },
    clearSearchKey() {
      this.searchKey = '';
    },
    loginOut() {
      this.httpGet('admin/logout').then((data) => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('_TOKEN_');
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        sessionStorage.removeItem('userInfo');
        this.userInfo = {};
        this.$router.push({
          path: '/forecast/dashboard'
        });
      });
    },
    // closeDialog(){
    //     this.$store.commit('setPerssion',false)
    //     this.userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {}
    // },
    openDialog() {
      this.$store.commit('setPerssion', true);
    },
    loginEvent() {
      if (!this.model.name) {
        this.$message({
          message: '请输入用户名',
          type: 'warning'
        });
        return;
      }
      if (!this.model.password) {
        this.$message({
          message: '请输入密码',
          type: 'warning'
        });
        return;
      }

      this.httpGet(`admin/login?name=${encodeURIComponent(this.model.name)}&password=${this.model.password}`).then(
        (data) => {
          if (data && data.statusCode == 1) {
            window.localStorage.setItem('token', data.data);
            sessionStorage.setItem('_TOKEN_', data.data);
            window.localStorage.removeItem('loginInfo');
            if (this.model.name && this.model.password) {
              let info = {
                name: encodeURIComponent(this.model.name),
                password: encodeURIComponent(this.model.password)
              };
              window.localStorage.setItem('loginInfo', JSON.stringify(info));
            }

            this.httpGet(`admin/user`).then((res) => {
              if (res && res.statusCode == 1) {
                localStorage.setItem('userInfo', JSON.stringify(res.data));
                sessionStorage.setItem('_USER_INFO_', JSON.stringify(res.data));
                this.userInfo = res.data;
                this.$message({
                  message: '登录成功',
                  type: 'success'
                });
                this.$router.go(0);
              } else {
                this.$message({
                  message: res.message,
                  type: 'warning'
                });
              }
            });
            this.$store.commit('setPerssion', false);
          } else {
            this.$message({
              message: data.message,
              type: 'warning'
            });
          }
        }
      );
    },
    goBack() {
      const curLocationHref = location.href;
      this.$router.go(-1);
      setTimeout(() => {
        if (curLocationHref === location.href) {
          this.$router.replace('/case/search');
        }
      }, 100);
    },
    goCenter() {
      this.$router.push({
        path: '/forecast/center'
      });
    }
  },
  destroyed() {
    if (this.payTimeOut) {
      clearInterval(this.payTimeOut);
    }
  }
};
</script>
<style scoped lang="less">
.layout-header {
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;

  .layout-header-user-info {
    display: flex;
    align-items: center;

    .system-expired-info {
      margin-right: 30px;

      .vip-time-info {
        display: flex;
        align-items: center;
        height: 24px;

        .vip-time-info-content {
          color: #fedda9;
          font-size: 12px;
          height: 24px;
          line-height: 24px;
          background: linear-gradient(270deg, #383e49 0%, #505868 100%);
          border-radius: 2px 0px 0px 2px;
          padding: 0 10px;

          .vip-time-info-img {
            width: 22px;
          }
        }
        .vip-time-info-renew-btn {
          color: #172237;
          font-size: 12px;
          line-height: 24px;
          background: #fedda9;
          border-radius: 0px 2px 2px 0px;
          padding: 0 10px;
          cursor: pointer;
        }
      }

      .vip-free-surplus {
        display: flex;
        align-items: center;
        color: #4e555b;
        font-size: 14px;
        line-height: 20px;

        .el-icon-question {
          position: relative;
          top: -1px;
          font-size: 16px;
          color: #e6a23c;
          cursor: pointer;
          margin-right: 2px;
        }

        .vip-free-surplus-btn {
          color: #172237;
          font-size: 12px;
          height: 24px;
          line-height: 24px;
          margin-left: 10px;
          background-color: #fedda9;
          border-radius: 2px;
          padding: 0 10px;
          cursor: pointer;
        }
      }
    }
  }
}
.layout-header-system {
  display: flex;
  align-items: center;
  margin: 0 50px 0 10px;

  .layout-header-system-back-btn {
    height: 32px;
    color: #172237;
    font-size: 14px;
    line-height: 32px;
    background: #f7f7f7;
    border-radius: 0px 100px 100px 0px;
    padding: 0 11px;
    margin-left: -20px;
    margin-right: 10px;
    cursor: pointer;

    .el-icon-arrow-left {
      margin-right: 2px;
    }
  }

  .layout-header-system-logo {
    height: 24px;
    cursor: pointer;
    margin-right: 10px;
  }
  .layout-header-system-label {
    color: #172237;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
  }
  .layout-header-system-enterprise {
    color: #3f6efc;
    font-size: 14px;
    line-height: 20px;
    border: 1px solid #3f6efc;
    border-radius: 8px 0 8px 0;
    padding: 0 10px;
    margin-left: 10px;
  }
}
.head-title {
  display: flex;
  position: relative;
}
.logo {
  position: absolute;
  width: 110px;
  left: 15px;
  top: 15px;
  cursor: pointer;
}

.menu-wrap {
  margin: 0 auto;
  display: flex;
}

.logo img {
  width: 100%;
}

.menu {
  line-height: 60px;
  color: rgba(255, 255, 255, 1);
}

.menu span {
  margin: 0 20px;
}

.menu a {
  color: #fff;
}

.forecast-topHead {
  a {
    font-size: 16px;
    color: #222;
    font-weight: bold;
    cursor: pointer;
  }
  span {
    font-size: 16px;
    color: #999;
    font-weight: bold;
  }
}
.header-portrait {
  display: flex;
  .pic {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    margin-right: 10px;
    background-color: #f2f2f2;
    display: inline-block;
  }
  .tel {
    color: #fff;
  }
}
.back {
  color: #fff;
  text-align: center;
  height: 30px;
  margin: 20px 15px;
  cursor: pointer;
}

.in-result {
  position: absolute;
  right: 40px;
  top: 0;
  color: #666666;
  background: #fff;
  height: 34px;
  line-height: 34px;
  width: 105px;
  box-sizing: border-box;
  border-top: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
}

.right-tools {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  z-index: 1001;
  font-size: 14px;
  color: #fff;
  text-align: center;
  padding: 14px 0;
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  -webkit-transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  -o-transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  -moz-transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  .tool-btn {
    background: rgba(34, 34, 34, 1);
    border-radius: 4px 0 0 4px;
    padding: 8px 0;
    cursor: pointer;
    margin-bottom: 10px;
    line-height: 20px;

    .collect-content {
      text-align: center;
      width: 20px;
      word-break: break-all;
      margin: 0 auto;
    }

    &.red-btn {
      background-color: #e02122;
    }
  }
}
.user {
  padding-top: 20px;
  margin-right: 20px;
  color: #fff;
  cursor: pointer;
  min-width: 90px;
}

.form {
  margin-top: 14px;
  position: relative;
  .send-number {
    position: absolute;
    display: inline-block;
    right: 10px;
    color: #e42626;
    top: 14px;
    cursor: pointer;
  }
}

.form p {
  color: rgba(92, 121, 176, 1);
  padding-bottom: 6px;
}

.search-bar {
  width: 500px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 13px;
  display: flex;
  background: #fff;
  border-radius: 3px;
  z-index: 99;
}

.search-bar input {
  flex: 1;
  width: 0;
  min-width: 200px;
  height: 24px;
  padding-left: 10px;
  font-size: 14px;
  color: @wordColor1;
  border-radius: 3px;
  margin: 5px;
  border: none !important;
}

.search-icon {
  width: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 4px;
}

.search-icon img {
  display: block;
  width: 100%;
}

.search-bar-input-content {
  box-sizing: border-box;
  width: 400px;
  max-height: 104px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #dcdfe6;
}

.search-bar-body {
  display: flex;
  position: relative;

  .case-input-item {
    height: 24px;
    line-height: 24px;
    margin: 5px;
    font-size: 14px;

    &.input-item {
      min-width: 300px;
      flex: 1;
      width: 0;
      input {
        width: 100%;
        height: 100%;
        font-size: 14px;
        border: none;
        outline: none;
      }
    }
  }
  .input-val {
    border-radius: 4px;
    background: #e6e6e6;
    padding: 0 26px 0 14px;
    cursor: pointer;
    overflow: hidden;

    .search-close-icon {
      position: absolute;
      z-index: 99;
      padding: 0 6px;
    }
  }
  .cur-input-val {
    background: #666;
    span {
      color: #fff;
    }
  }

  .input-tip-panel {
    box-sizing: border-box;
    position: absolute;
    top: 29px;
    left: 0px;
    width: 500px;
    background: #fff;
    z-index: 99;
    padding: 10px 18px;
    box-shadow: 0px 6px 11px 1px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    border: 1px solid rgba(230, 230, 230, 1);

    .input-tip-panel-title {
      color: #666666;
      font-size: 14px;
      line-height: 20px;
    }

    .input-tip-panel-li {
      color: #222;
      font-size: 12px;
      line-height: 17px;
      margin-top: 5px;

      .symbol-btn {
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #e42626;
        background-color: rgba(228, 38, 38, 0.1);
        cursor: pointer;
      }
    }
  }
  .relate-panel {
    width: 100%;
    max-height: 400px;
    overflow-y: auto;
    background: #fff;
    text-align: left;
    line-height: 20px;
    .relate-tip {
      margin-left: 20px;
    }
    .relate-item-list {
      margin-top: 10px;
      h5 {
        margin-bottom: 5px;
      }
    }
    .relate-item {
      line-height: 26px;
      cursor: pointer;
    }
    .relate-item:hover span {
      color: @mainColor !important;
    }
  }

  .accurate-button {
    position: absolute;
    width: 90px;
    right: -120px;
    z-index: 1999;
    top: -15px;
    cursor: pointer;
    .el-icon-caret-bottom {
      transition: all 0.4s ease;
    }
  }
}

.search-bar .search-button {
  width: 100px;
  height: 100%;
  background: rgba(27, 156, 255, 1);
  border-radius: 0px 3px 3px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.search-bar .search-button2 {
  width: 100px;
  height: 36px;
  background: #e42626;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  margin-left: 5px;
}
.search-bar .search-button3 {
  display: inline-block;
  width: 100px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  margin-left: 5px;
  color: #222;
}
.login-bar {
  height: 60px;
  line-height: 60px;
  cursor: pointer;
  padding: 0 20px;
  color: #fff;
  min-width: 60px;
}
.code-panel h4 {
  color: #f86359;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.code-panel .if {
  color: #212731;
  margin-bottom: 35px;
}

.code-bar p {
  margin-bottom: 8px;
  color: @wordColor1;
}
</style>

<style lang="less">
.dialog-hide-header-content {
  .close-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    padding: 10px;
    cursor: pointer;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0 0 30px;

    .collect-pane-container {
      min-height: 200px;
      max-height: 600px;
      overflow: auto;
    }
  }
}
.type-select .el-input__inner {
  height: 34px;
  line-height: 34px;
  padding-left: 25px;
}
.type-select .el-input .el-select__caret {
  font-size: 16px !important;
}
.accurate-panel {
  width: 1200px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 11px 1px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(230, 230, 230, 1);
  position: fixed;
  z-index: 999;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  border-top: 3px solid #e42626;
}

.memberDialog .el-dialog__body {
  padding-top: 0;
}

.vip-pane .el-dialog__body {
  padding: 0;
}

.memberDialog .el-dialog__header {
  padding: 0;
  text-align: center;
  color: rgba(79, 94, 123, 1);
  border-bottom: 1px solid rgba(215, 229, 249, 1);
  padding: 12px 0;
}

.el-cascader__search-input {
  border: none !important;
}

.memberDialog .el-dialog__headerbtn {
  top: 13px;
  right: 13px;
}

.memberDialog .el-dialog__title {
  color: rgba(79, 94, 123, 1);
  font-size: 16px;
}

.in-result .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/cases/Layout.vue